export const SUPER_ADMIN = 'SuperAdmin'
export const ADMIN = 'Admin'

export const isAdminOrSuper = (role) => [SUPER_ADMIN, ADMIN].includes(role)
